// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","inner":"Header_inner__5S7p8","logoContainer":"Header_logoContainer__MYmTl","logo":"Header_logo__UsziS"};